import { ActionType } from 'typesafe-actions';
import * as lotteryPaymentActions from './lotteryPaymentActions';
import BaseReducer, { baseInitialState} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';


export type LotteryPaymentGridAction = ActionType<typeof lotteryPaymentActions>;

export interface ILotteryPaymentStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: {} };
	readonly queries: { [queryKey: string]: [] };
}

export function lotteryPaymentReducer(
	state = baseInitialState as ILotteryPaymentStateType,
	action: LotteryPaymentGridAction,
) {
	const Reducer = new BaseReducer('lotteryPaymentReducer');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}

